module.exports = __webpack_public_path__ + "img/objects-links-info.7d58bbc.webp";